import type { NotificationData } from '@mantine/notifications';

/**
 * Default timeout in milliseconds before notifications automatically close
 */
const AUTO_CLOSE_TIMEOUT: number = 5000;

/**
 * Default position where notifications will appear on the screen
 * Uses Mantine's notification positioning system
 */
const DEFAULT_POSITION: NotificationData['position'] = 'top-center';

export { AUTO_CLOSE_TIMEOUT, DEFAULT_POSITION };
